/* eslint-disable react/prop-types */
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import TimeSlot from "./TimeSlot";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    alignItems: "flex-start",
  },
  timeSlots: {
    display: "flex",
    flexDirection: "column",
    "&>*": {
      marginTop: 8,
    },
  },
}));

const DayRow = (props) => {
  const { setValue, control, getValues, errors } = useFormContext();

  const { day, index, disabled, isFirst } = props;
  const classes = useStyles();
  const name = day.name;

  const { append, remove, fields } = useFieldArray({
    control: control,
    name: `${name}.slots`,
  });

  useEffect(() => {
    if (fields.length == 0) append({ start: "09:00am", end: "05:00pm" });
  }, [fields]);

  return (
    <>
      <div key={day.short} className={classes.root}>
        <div
          style={{
            width: 120,
            marginTop: 8,
            height: 36,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography style={{ fontSize: 14 }}>{day.name}</Typography>
        </div>
        <div className={classes.timeSlots}>
          {fields.map((slot, i) => (
            <TimeSlot
              {...{ disabled, isFirst }}
              key={slot.id}
              slot={slot}
              index={i}
              dayIndex={index}
              slotsCount={fields.length}
              day={day}
              errors={errors}
              onAdd={() => {
                append({ start: "09:00am", end: "05:00pm" });
              }}
              onDelete={(item, toDeleteIndex) => {
                console.log("toDeleteIndex", toDeleteIndex);
                remove(toDeleteIndex);
              }}
              onCopy={(item) => {
                let values = getValues();
                let keys = Object.keys(values).filter(
                  (k) => k != "workingHoursEnabled" && k != "meal"
                );

                for (let k of keys) {
                  if (k != item.name)
                    setValue(`${k}.slots`, [...values[item.name].slots], {
                      shouldValidate: true,
                    });
                }
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default DayRow;
